<!-- <div [excels]="excels" [hf]="hf" [sheetid]="sheetid" [CONFIGURATION]="CONFIGURATION" [dataset]="dataset"
    [showAnimations]="showAnimations"></div> -->

<div class="row" style="padding: 6px 3px;">
    <div class="col-md-12">
        <mat-tab-group>
            <mat-tab label="Own Projects">
                <!-- Main vertical flex container for the tab content -->
                <div style="display: flex; flex-direction: column; height: calc(85vh);">
                    <!-- Search input section (takes full width, doesn't grow/shrink) -->
                    <div style="width: 100%; flex-shrink: 0;">
                        <mat-form-field class="search-field" appearance="outline" style="width: 100%;">
                            <mat-label>Search own projects</mat-label>
                            <input matInput [(ngModel)]="searchText" (keyup)="filterProjects()" [disabled]="isLoadingOwnProjects">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </div>
                    <!-- Separator -->
                    <hr style="width: 100%; margin: 8px 0; flex-shrink: 0;">
                    <!-- Scrollable content area (takes remaining vertical space) -->
                    <div style="flex-grow: 1; overflow-y: auto;">
                        <!-- Wrapper for project items (horizontal flow, wraps) -->
                        <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px; padding: 5px;">
                            <div *ngIf="isLoadingOwnProjects" class="loading-container"
                                style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100px;">
                                <mat-spinner diameter="40"></mat-spinner>
                                <p>Loading projects...</p>
                            </div>
                            <div class="projectbtn" *ngFor="let p of filteredProjects">
                                <img *ngIf="p.image" [src]="p.image" (click)="projectSelected(p)" />
                                <div *ngIf="!p.image" style="width: 130px; height: 130px; background-color: white;" (click)="projectSelected(p)"></div>
                                <div>{{p.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab label="Public Projects">
                <!-- Main vertical flex container for the tab content -->
                <div style="display: flex; flex-direction: column; height: calc(85vh);">
                    <!-- Search input section (takes full width, doesn't grow/shrink) -->
                    <div style="width: 100%; flex-shrink: 0;">
                        <mat-form-field class="search-field" appearance="outline" style="width: 100%;">
                            <mat-label>Search public projects</mat-label>
                            <input matInput [(ngModel)]="publicSearchText" (keyup)="filterPublicProjects()" [disabled]="isLoadingPublicProjects">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                    </div>
                    <!-- Separator -->
                    <hr style="width: 100%; margin: 8px 0; flex-shrink: 0;">
                    <!-- Scrollable content area (takes remaining vertical space) -->
                    <div style="flex-grow: 1; overflow-y: auto;">
                        <div *ngIf="isLoadingPublicProjects" class="loading-container"
                            style="width: 100%; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100px;">
                            <mat-spinner diameter="40"></mat-spinner>
                            <p>Loading projects...</p>
                        </div>
                        <!-- Show tree when no search -->
                        <ng-container *ngIf="!publicSearchText && !isLoadingPublicProjects">
                            <!-- Assuming app-examples handles its internal layout -->
                            <!-- <app-examples [treenodes]="nodes" [idstr]="'publicCategoryID'"></app-examples> -->
                        </ng-container>
                        <!-- Show flat list when searching -->
                        <ng-container *ngIf="publicSearchText && !isLoadingPublicProjects">
                            <!-- Wrapper for project items (horizontal flow, wraps) -->
                            <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px; padding: 5px;">
                                <div class="projectbtn" *ngFor="let p of filteredPublicProjects">
                                    <img [src]="p.image" (click)="projectSelected(p)" />
                                    <div>{{p.name}}</div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>